import { CATEGORIES } from "@/lib/api";

export const EMPTY = {
  name: "", brand: "", category: "kedi", sub_type: "Kuru Mama", weight: "", flavor: "", price: "", discount_pct: 0,
  bulk_min_qty: 0, bulk_discount_pct: 0, stock: 0, cargo_included: false, hidden_cargo_cost: 0, is_campaign: false,
  image: "", images: [], description: "", features: [], active: true,
};

export const COLS = ["Ürün adı", "Marka", "Kategori", "Kg / Gram", "Çeşit", "Fiyat (TL)", "İskonto %", "Toplu min.", "Toplu %", "Stok", "Kargo", "Gizli kargo TL", "Kampanya"];

const cell = "h-9 border border-slate-300 rounded px-2 text-sm bg-white outline-none focus:border-[#172554] w-full";

export function ProductRowInputs({ v, set, prefix }) {
  const f = (k, type = "text", extra = {}) => (
    <input data-testid={`${prefix}-${k}`} type={type} value={v[k]} {...extra}
      onChange={(e) => set({ ...v, [k]: type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value })}
      className={cell} />
  );
  return (
    <>
      <td className="p-1 min-w-[190px]">{f("name", "text", { placeholder: "ör. Kedi Maması Tavuklu" })}</td>
      <td className="p-1 min-w-[110px]">{f("brand")}</td>
      <td className="p-1 min-w-[95px]">
        <select data-testid={`${prefix}-category`} value={v.category} onChange={(e) => set({ ...v, category: e.target.value })} className={cell}>
          {CATEGORIES.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
        </select>
      </td>
      <td className="p-1 min-w-[80px]">{f("weight", "text", { placeholder: "3 kg" })}</td>
      <td className="p-1 min-w-[95px]">{f("flavor", "text", { placeholder: "Tavuklu" })}</td>
      <td className="p-1 min-w-[95px]">{f("price", "number", { min: 0, step: "0.01" })}</td>
      <td className="p-1 min-w-[70px]">{f("discount_pct", "number", { min: 0, max: 90 })}</td>
      <td className="p-1 min-w-[70px]">{f("bulk_min_qty", "number", { min: 0 })}</td>
      <td className="p-1 min-w-[65px]">{f("bulk_discount_pct", "number", { min: 0, max: 90 })}</td>
      <td className="p-1 min-w-[70px]">{f("stock", "number", { min: 0 })}</td>
      <td className="p-1 min-w-[150px]">
        <select data-testid={`${prefix}-cargo`} value={v.cargo_included ? "biz" : "musteri"} onChange={(e) => set({ ...v, cargo_included: e.target.value === "biz" })} className={cell}>
          <option value="musteri">Müşteri öder</option>
          <option value="biz">Kargo bizden (fiyata ekle)</option>
        </select>
      </td>
      <td className="p-1 min-w-[80px]">{f("hidden_cargo_cost", "number", { min: 0, disabled: !v.cargo_included })}</td>
      <td className="p-1 text-center">
        <input data-testid={`${prefix}-campaign`} type="checkbox" checked={v.is_campaign} onChange={(e) => set({ ...v, is_campaign: e.target.checked })} className="h-4 w-4 accent-[#16A34A]" />
      </td>
    </>
  );
}

export const toPayload = (v) => ({
  ...EMPTY, ...v,
  price: Number(v.price || 0), discount_pct: Number(v.discount_pct || 0), bulk_min_qty: Number(v.bulk_min_qty || 0),
  bulk_discount_pct: Number(v.bulk_discount_pct || 0), stock: Number(v.stock || 0), hidden_cargo_cost: Number(v.hidden_cargo_cost || 0),
});
